const BadRequestMessageStatusTypes = {
    INVALID_TOKEN: "INVALID_TOKEN",
    INVALID_RECAPTCHA_TOKEN: "INVALID_RECAPTCHA_TOKEN",
    PASSWORD_AND_CONFIRM_ARE_NOT_EQUAL: "PASSWORD_AND_CONFIRM_ARE_NOT_EQUAL",
    PASSWORD_IS_INCORRECT: "PASSWORD_IS_INCORRECT",
    EMAIL_IS_INCORRECT: "EMAIL_IS_INCORRECT",
    USER_NOT_FOUND: "USER_NOT_FOUND",
} as const;
export type BadRequestMessageStatusTypes = keyof typeof BadRequestMessageStatusTypes;

export const BadRequestException = (messageCode: BadRequestMessageStatusTypes | string, message: string) => ({
    error: new Error(message),
    status: messageCode,
    code: 400
})